"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchOptions = getFetchOptions;
exports["default"] = exports.setXsrfToken = exports.resetXsrfToken = exports.performFetch = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

require("isomorphic-fetch");

var _runtimeConfigHelper = require("./helpers/runtime-config-helper");

var _brandHelper = require("./helpers/brand-helper");

var _fetchHelper = require("./helpers/fetch-helper");

var _urlHelper = require("./helpers/url-helper");

var _currentLanguageHelper = _interopRequireDefault(require("./helpers/current-language-helper"));

var _apiKeyHelper = require("./helpers/api-key-helper");

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _staticCallback = _interopRequireDefault(require("./hooks/static-callback"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

if (typeof window !== 'undefined') {
  window._xsrfToken = window._xsrfToken || null;
} // wrapper for every fetch action
// adding 'simpleCall' options. With this option, it would not auto inject
// any requests with X-XSRF-TOKEN.


var fetchWrapper = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
    var options,
        fetchOptions,
        method,
        xsrfDisabled,
        xsrftokenName,
        xsrftokenHostedBrands,
        fetchXsrfTokenSiteName,
        xsrfPreAuth,
        headers,
        result,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

            if (!(url.indexOf('credit_card/auth') < 0 && !options.simpleCall)) {
              _context.next = 25;
              break;
            }

            fetchOptions = (0, _pick["default"])(options, ['method', 'headers', 'body', 'redirect', 'signal', 'follow', 'timeout', 'compress', 'size', 'agent']); // TODO - remove this feature on next major update

            if (options.fetchOptions) {
              if (process.env.NODE_ENV !== 'production') {
                console.warn('fetch(url, { fetchOptions, ...otherOptions }) has been deprecated, instead pass in a flat object containing all your required options to fetch as the second argument');
              }

              fetchOptions = _objectSpread(_objectSpread({}, fetchOptions), options.fetchOptions);
            }

            options = getFetchOptions(_objectSpread(_objectSpread({}, options), {}, {
              url: url,
              fetchOptions: fetchOptions
            }));
            method = (options.method || 'GET').toUpperCase();
            xsrfDisabled = (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenDisabled;

            if (!(method !== 'GET' && xsrfDisabled !== true)) {
              _context.next = 25;
              break;
            }

            xsrftokenName = (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenHeaderName || 'X-XSRF-TOKEN';

            if (!getXsrfToken()) {
              _context.next = 13;
              break;
            }

            options.headers[xsrftokenName] = getXsrfToken();
            _context.next = 25;
            break;

          case 13:
            // Do the preauth call when the setting is enabled (this is used to override the default check for hosted brands)
            xsrftokenHostedBrands = (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenHostedBrands || !(0, _brandHelper.isHostedBrand)();

            if (!xsrftokenHostedBrands) {
              _context.next = 25;
              break;
            }

            fetchXsrfTokenSiteName = (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenSiteName;

            if (!fetchXsrfTokenSiteName) {
              _context.next = 25;
              break;
            }

            xsrfPreAuth = (0, _urlHelper.getUrl)((0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenSiteName, (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenEndpoint);
            headers = {
              'Accept-Language': 'en-us'
            };

            if ((0, _isFunction["default"])(_fetchHelper.globalModifyHeader) && !fetchOptions.simpleCall) {
              (0, _fetchHelper.globalModifyHeader)(headers);
            }

            _context.next = 22;
            return fetch(xsrfPreAuth, {
              method: 'POST',
              headers: headers,
              credentials: 'include'
            });

          case 22:
            result = _context.sent;
            setXsrfToken(result.headers.get(xsrftokenName));
            options.headers[xsrftokenName] = getXsrfToken();

          case 25:
            return _context.abrupt("return", fetch(url, options));

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchWrapper(_x) {
    return _ref.apply(this, arguments);
  };
}();

var handleResponse = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(response) {
    var _response$headers$get;

    var responseContent, contentType;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return response.text();

          case 2:
            responseContent = _context2.sent;

            if (!(responseContent.length === 0)) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", undefined);

          case 5:
            contentType = (_response$headers$get = response.headers.get('Content-Type')) !== null && _response$headers$get !== void 0 ? _response$headers$get : '';

            if (!contentType.includes('application/json')) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", JSON.parse(responseContent));

          case 8:
            return _context2.abrupt("return", responseContent);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function handleResponse(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getXsrfToken = function getXsrfToken() {
  return window && window._xsrfToken;
};

var resetXsrfToken = function resetXsrfToken() {
  if (typeof window !== 'undefined') {
    window._xsrfToken = undefined;
  }
};

exports.resetXsrfToken = resetXsrfToken;

var setXsrfToken = function setXsrfToken(xsrfToken) {
  if (typeof window !== 'undefined') {
    window._xsrfToken = xsrfToken;
  }
};

exports.setXsrfToken = setXsrfToken;

function getFetchOptions(options) {
  var incomingFetchOptions = options.fetchOptions || {};

  var fetchOptions = _objectSpread({
    headers: {}
  }, incomingFetchOptions); // Exclude credentials for cdn calls


  if ((0, _urlHelper.isKnownCdnUrl)(options.url)) {
    fetchOptions.credentials = 'same-origin';
  }

  if (!options.skipCredentials) {
    // Include credentials header / cookies in the fetch
    fetchOptions.credentials = 'include'; // set current Language in request

    var language = (0, _currentLanguageHelper["default"])();
    fetchOptions.headers = _objectSpread(_objectSpread({}, fetchOptions.headers), {}, {
      'Accept-Language': language
    });
  } // Automatic resolve api key's


  if (options.apikey && options.apikey !== '') {
    var resolvedKey = (0, _apiKeyHelper.getApiKey)(options.apikey);

    if (resolvedKey) {
      fetchOptions.headers = _objectSpread(_objectSpread({}, fetchOptions.headers), {}, {
        'x-api-key': resolvedKey
      });
    }
  }

  if ((0, _isFunction["default"])(_fetchHelper.globalModifyHeader) && !fetchOptions.simpleCall) {
    (0, _fetchHelper.globalModifyHeader)(fetchOptions.headers);
  }

  return fetchOptions;
}

var performFetch = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(url) {
    var options,
        _options$headers,
        response,
        data,
        _args3 = arguments;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};

            if ((0, _typeof2["default"])(options.body) === 'object') {
              options.body = JSON.stringify(options.body);
              options.headers = _objectSpread({
                'Content-Type': 'application/json'
              }, (_options$headers = options.headers) !== null && _options$headers !== void 0 ? _options$headers : {});
            }

            _context3.next = 4;
            return fetchWrapper(url, options);

          case 4:
            response = _context3.sent;
            _context3.next = 7;
            return handleResponse(response);

          case 7:
            data = _context3.sent;

            if (!options.skipStatusCallback && typeof _staticCallback["default"].onHandleStatus === 'function') {
              _staticCallback["default"].onHandleStatus(response.status, data);
            }

            if (!options.dontShowErrorsInNotificationBar && (data === null || data === void 0 ? void 0 : data.message) != null) {
              if (window != null) {
                if (response.status !== 402) {
                  // Don't show for Payment error status 402
                  // Pass the message to the notification bar to show the error message
                  window.postMessage({
                    type: 'fetch_notification',
                    message: data.message,
                    persistent: data.persistent
                  }, window.document.origin);
                }
              }
            }

            return _context3.abrupt("return", data);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function performFetch(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.performFetch = performFetch;
var _default = fetchWrapper;
exports["default"] = _default;